__turbopack_context__.v({
  "desktopMenu": "DesktopMenuPopover-module-scss-module__uMgnhq__desktopMenu",
  "internal": "DesktopMenuPopover-module-scss-module__uMgnhq__internal",
  "popoverArrow": "DesktopMenuPopover-module-scss-module__uMgnhq__popoverArrow",
  "popoverContent": "DesktopMenuPopover-module-scss-module__uMgnhq__popoverContent",
  "popoverInnerContent": "DesktopMenuPopover-module-scss-module__uMgnhq__popoverInnerContent",
  "popoverOpen": "DesktopMenuPopover-module-scss-module__uMgnhq__popoverOpen",
  "popoverOverlay": "DesktopMenuPopover-module-scss-module__uMgnhq__popoverOverlay",
});
